import { lazy } from 'react-loosely-lazy';

export const LazyPortalSettingsAnnouncementSidebar = lazy(
    () =>
        import(/* webpackChunkName: "portal-settings-announcement-sidebar" */ './portal-settings-announcement-sidebar')
);
